import React from "react";
import { useTranslation } from "react-i18next";
import HeadingLayout from "src/components/base/heading-layout";
import Markdown from "react-markdown";
import { Heading, Subheading } from "src/components/base/heading";
import { Text } from "src/components/base/text";
import CHANGELOG_CONTEXT from "src/context/changelog";
import { Divider } from "src/components/base/divider";

/**
 * The properties for {@link ChangelogOverview}
 */
export type ChangelogOverviewProps = {};

/**
 * A component to display the changelog
 */
export default function ChangelogOverview(props: ChangelogOverviewProps) {
    const [t] = useTranslation("changelog");

    const { changelog } = React.useContext(CHANGELOG_CONTEXT);

    const customMarkdown = {
        h1: ({ ...props }) => <Heading {...props} />,
        h2: ({ ...props }) => <Subheading {...props} />,
        h3: ({ ...props }) => <Subheading {...props} />,
        p: ({ ...props }) => <Text {...props} />,
        ul: ({ ...props }) => (
            <ul
                {...props}
                className={"list-inside list-disc text-base/6 text-zinc-500 sm:text-sm/6 dark:text-zinc-400"}
            />
        ),
        hr: ({ ...props }) => <Divider {...props} />,
    };

    return (
        <HeadingLayout heading={t("heading.overview")}>
            <div className={"flex flex-col gap-6"}>
                <Markdown components={customMarkdown}>{changelog}</Markdown>
            </div>
        </HeadingLayout>
    );
}
